import { render } from "./Tenants.vue?vue&type=template&id=2c8b5d86&scoped=true"
import script from "./Tenants.vue?vue&type=script&lang=js"
export * from "./Tenants.vue?vue&type=script&lang=js"

import "./Tenants.vue?vue&type=style&index=0&id=2c8b5d86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8b5d86"]])

export default __exports__